import React from 'react';
import { useSharePanelStore } from 'src/common/store/share.store';

export const ShareLinkPersonalizationBanner = () => {
  const { personalizationLogoUrl } =
    useSharePanelStore(
      (state) => ({
        personalizationLogoUrl:
          state.activeAlias?.personalization?.logo_url || state.activeAlias?.personalization_logo_url || null,
      }),
    );
  
  if (personalizationLogoUrl) {
    return (
      <div className="bg-bedrock-light-gray rounded-lg p-2 !mt-4">
        <div className="flex items-center space-x-2">
          <img className="w-6 h-6 rounded-sm" src={personalizationLogoUrl} alt="Prospect Logo" />
          <div className="text-bedrock-p-small text-bedrock-black">
            We’re personalizing the Journey with this logo.
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="text-bedrock-p-small text-bedrock-black">
      By using your recipients domain we’ll include their logo into this Journey
    </div>
  )
}